var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavDashboards(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2893 2.99414H7.95167C5.12927 2.99414 3.35999 4.99094 3.35999 7.8191V15.4482C3.35999 18.2764 5.12159 20.2741 7.95167 20.2741H16.0483C18.8793 20.2741 20.64 18.2764 20.64 15.4482V13.5791",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.759 2.8801C19.5374 2.8801 21.1641 4.1401 22.0799 6.2401C21.1641 8.3401 19.5374 9.6001 17.759 9.6001C15.9825 9.6001 14.3558 8.3401 13.4399 6.2401C14.3558 4.13914 15.9825 2.8801 17.7609 2.8801H17.759Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1999 6.23993C19.1999 5.44537 18.555 4.79993 17.7602 4.79993C16.9645 4.79993 16.3199 5.44537 16.3199 6.23993C16.3199 7.03497 16.9649 7.67993 17.7602 7.67993C18.555 7.67993 19.1999 7.03497 19.1999 6.23993Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52063 11.5297V16.4967M11.5526 8.69385V16.4967M15.5184 13.7022V16.4958",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavDashboards);
export default __webpack_public_path__ + "static/media/icon-nav-dashboards.289e8956c1f18b96d5334c4fd491f838.svg";
export { ForwardRef as ReactComponent };